import { getProvidersData } from '../../helpers/data-helper';
import ReviewCard from './Review-Card/Review-Card'

export default {
	data: function() {
		return {
			providers_data: {},
			providers: []
		}
	},
	props: ['inverted'],
	components: {
		'review-card': ReviewCard,
	},
	mounted: function() {
		this.providers_data = getProvidersData();
		for(var key in this.providers_data) {
			this.providers.push(key);
		}
	},
}


// WEBPACK FOOTER //
// ./src/common/Reviews/reviews.js